import React, { useEffect, useState } from 'react';
import RecievedCallReportingService from '../../Report/Callcenter/ReceivedCall/service';
import OutgoingCallReportingService from '../../Report/Callcenter/CallMade/service';
import PbxipCallReceivedService from '../../Report/PBXIP/ReceivedCall/service';
import PbxipCallOutgoingService from '../../Report/PBXIP/CallMade/service';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  PAGE,
  QUERY_PARAMS_CARDS,
  QUERY_PARAMS_CALLIN,
  REPORT_TYPE_DETAILEDSYNTHETIC,
  dateBegin,
  dateEnd,
  currentMont,
  TIME_INTERVAL,
  QUERY_PARAMS_PBXIP,
  QUERY_PARAMS_COMBINED_CALL
} from './assets/consts';

import { calculateServiceLevel } from './assets/calculateServiceLevel';

import { Container, Row, Col, Button } from 'reactstrap';
import AlternativeHeader from 'components/Headers/AlternativeHeader.js';
import FlexSelect from 'components/Inputs/FlexSelect';
import TopCards from './components/CardItem';
import CallCenterCallGraphicsIncomingCalls from './components/CallcenterCallGraphics/IncomingCalls';
import CallCenterCallGraphicsOutgoingCalls from './components/CallcenterCallGraphics/OutgoingCalls';
import PbxipCallGraphicsIncomingCalls from './components/PbxipCallGraphics/IncomingCalls';
import PbxipCallGraphicsOutgoingCalls from './components/PbxipCallGraphics/OutgoingCalls';
import { useCalculateStatisticalData } from '../../Monitoring/Queue/MonitoringScreen/components/AsideCards/AsideCardsList/useCalculateStatisticalData';
import { UserNotLoggedIn } from 'views/Monitoring/SupervisorPanel/components/QueueTable/styled';
import { FiMeh } from 'react-icons/fi';

/**
 * @description: Tela de Dashboard do Call Center e tela de Dashboard do Pbxip
 * foi feito ambas no mesmo arquivo com a diferença de um useState basicamente (isFromPBXIP)
 */

import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { format, startOfMonth } from 'date-fns';
import { ErrorMessage } from '@hookform/error-message';
import { dateRules } from 'views/Report/Callcenter/utils/rulesValidation';
import Datepicker from 'components/Inputs/DatePicker.js';
import UserService from 'views/User/service';
import { AgentHorizontalBarChart } from './components/CallcenterCallGraphics/AgentHorizontalBarChart';
import { AgentPieChart } from './components/CallcenterCallGraphics/AgentPieChart';
import { TopCardsContainer } from './assets/style';
import { CallsPerHourBarChart } from './components/CallcenterCallGraphics/CallsPerHourBarChart';
import useQueues from 'hooks/useQueues';
import FormTooltip from 'components/Inputs/FormTooltip';

const styleTime = {
  color: '#fff',
  fontSize: '2.1rem',
  margin: '0',
  padding: '0'
};

const validateGraphData = (data, graphName) => {
  if (!data || data.length === 0) {
    toast.info(`${graphName} está vazio ou não possui dados.`);
    return false;
  }

  const hasInvalidData = data.some(
    (item) =>
      item === undefined ||
      item === null ||
      (typeof item === 'number' && isNaN(item))
  );

  if (hasInvalidData) {
    toast.error(`${graphName} contém dados inválidos.`);
    return false;
  }

  return true;
};

const Dashboard = () => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { watch, setValue, control, errors, getValues } = useForm();
  const [dataCarts, setDataCarts] = useState({});
  const [dataServiceLevel, setDataServiceLevel] = useState({});
  const [dataForIncomingCallGraph, setDataForIncomingCallGraph] = useState([]);
  const [dataForOutCallGraph, setDataOutCallGraph] = useState([]);
  const [dataForIncomingPbxipGraph, setDataForIncomingPbxipGraph] = useState(
    []
  );
  const [dataForOutPbxipGraph, setDataForOutPbxipGraph] = useState([]);
  const queueValue = watch('queuesid');
  const { calculeConform, calculeNotConfor } = calculateServiceLevel();
  const {
    getTME,
    getTMA,
    getAnsweredCalls,
    getAbandonedCalls,
    getOutgoingAbandonedCalls,
    getOutgoingAnsweredCalls
  } = useCalculateStatisticalData();
  const [isFromPBXIP, setIsFromPBXIP] = useState();
  const { fetch: fetchQueues, response: queues } = useQueues({
    types: ['is_telephony']
  });
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const { getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.REPORT_CALL_CENTER_INCOMING_CALLS
  );

  /**
   * @description: Specifies where the filters are saved in the local storage
   * dateBeginValue, dateEndValue and agentValue
   */
  const dateBeginValue = watch('dateBegin');
  const dateEndValue = watch('dateEnd');
  const agentValue = watch('agent');

  const [combinedCallData, setCombinedCallData] = useState({
    incoming: [],
    outgoing: []
  });

  /**
   * @description: Takes `hourBegin` and `hourEnd`, formats them to pass as parameters in backend requests
   * timeStart e timeEnd
   */
  const timeStart = QUERY_PARAMS_CARDS.hourBegin.replace(/:/g, '');
  const timeEnd = QUERY_PARAMS_CARDS.hourEnd.replace(/:/g, '');

  /**
   * @description: Takes data retrieved from the backend (as an object of arrays) and splits it into two arrays
   * incoming e outgoing
   */
  const incoming = combinedCallData.incoming || [];
  const outgoing = combinedCallData.outgoing || [];

  /**
   * @description: Handles the submission of the form
   * @returns {void}
   */
  const onSubmit = async () => {
    try {
      if (errors.dateBegin || errors.dateEnd) return;
      if (!queueValue) return;
      if (loading) return;
      setLoading(true);
      setSearchClicked(true);
      await Promise.all([
        getMontServiceLevel(
          queueValue,
          dateBeginValue,
          dateEndValue,
          agentValue
        ),
        getDataDashboard(queueValue, dateBeginValue, dateEndValue, agentValue),
        fetchCombinedCallData(
          queueValue,
          dateBeginValue,
          dateEndValue,
          agentValue
        ),
        getDataForIncomingCallGraph(
          queueValue,
          dateBeginValue,
          dateEndValue,
          agentValue
        ),
        getDataForOutgoingCallGraph(
          queueValue,
          dateBeginValue,
          dateEndValue,
          agentValue
        )
      ]);

      if (isFromPBXIP) {
        getDataForPbxipIncomingCallGraph();
        getDataForPbxipOutgoingCallGraph();
      }
      const interval = setInterval(() => {
        getDataForPbxipIncomingCallGraph();
        getDataForPbxipOutgoingCallGraph();
      }, TIME_INTERVAL);
      setLoading(false);
      return () => clearInterval(interval);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getUser = () => {
    UserService.getAll(false, undefined, undefined, false)
      .then((response) => {
        setUsers(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  };

  /**
   * @description: This function is used to get the name of the agent based on the agent code
   * Enables the agent filter functionality for the charts
   * @returns {string} - The name of the agent
   * @param {Array} agentCodes - The array of agent codes
   * @type {string}
   */
  const getAgentNames = (agentCodes) => {
    if (!agentCodes || !Array.isArray(agentCodes)) return '';

    return agentCodes
      .map((code) => {
        const user = users.find((u) => u.agent_code === code);
        return user ? user.name : code;
      })
      .join(',');
  };

  const getDataDashboard = (queue, dateBegin, dateEnd, agent) => {
    const agentNames = getAgentNames(agent);
    const queryParams = {
      ...QUERY_PARAMS_CARDS,
      ...(queue && queue.length > 0 && { queue: queue.join(',') }),
      dateBegin: `${toISOFormat(dateBegin)} ${QUERY_PARAMS_CARDS.hourBegin}`,
      dateEnd: `${toISOFormat(dateEnd)} ${QUERY_PARAMS_CARDS.hourEnd}`,
      timeStart: timeStart,
      timeEnd: timeEnd,
      ...(agent &&
        agent.length > 0 && { agent: agent.join(','), agentName: agentNames })
    };
    RecievedCallReportingService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      queryParams
    )
      .then((response) => {
        const { data } = response.data;
        setDataCarts(data);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  const getMontServiceLevel = (queue, dateBegin, dateEnd, agent) => {
    const agentNames = getAgentNames(agent);
    const queryParams = {
      ...QUERY_PARAMS_CARDS,
      ...(queue && queue.length > 0 && { queue: queue.join(',') }),
      dateBegin: `${toISOFormat(dateBegin)} ${QUERY_PARAMS_CARDS.hourBegin}`,
      dateEnd: `${toISOFormat(dateEnd)} ${QUERY_PARAMS_CARDS.hourEnd}`,
      timeStart: timeStart,
      timeEnd: timeEnd,
      ...(agent &&
        agent.length > 0 && { agent: agent.join(','), agentName: agentNames })
    };
    RecievedCallReportingService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      queryParams
    )
      .then((response) => {
        const { listCallDetailedSyntheticCallCenterDTO } = response.data.data;
        setDataServiceLevel(listCallDetailedSyntheticCallCenterDTO);
      })
      .catch((error) => {
        console.log('error na request nivel de serviço', error);
      });
  };

  const getDataForIncomingCallGraph = (queue, dateBegin, dateEnd, agent) => {
    const agentNames = getAgentNames(agent);
    const queryParams = {
      ...QUERY_PARAMS_CALLIN,
      ...(queue && queue.length > 0 && { queue: queue.join(',') }),
      dateBegin: `${toISOFormat(dateBegin)} ${QUERY_PARAMS_CARDS.hourBegin}`,
      dateEnd: `${toISOFormat(dateEnd)} ${QUERY_PARAMS_CARDS.hourEnd}`,
      timeStart: timeStart,
      timeEnd: timeEnd,
      dataForIncomingCallGraph: 'dataForIncomingCallGraph',
      ...(agent &&
        agent.length > 0 && { agent: agent.join(','), agentName: agentNames })
    };
    RecievedCallReportingService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      queryParams
    )
      .then((response) => {
        const { listCallDetailedSyntheticCallCenterDTO } = response.data.data;
        if (
          validateGraphData(
            listCallDetailedSyntheticCallCenterDTO,
            'Gráfico de Chamadas Recebidas'
          )
        ) {
          setDataForIncomingCallGraph(listCallDetailedSyntheticCallCenterDTO);
        }
      })
      .catch((error) => {
        console.log('error na request chamadas recebidas ', error);
      });
  };

  const getDataForOutgoingCallGraph = (queue, dateBegin, dateEnd, agent) => {
    const agentNames = getAgentNames(agent);
    const queryParams = {
      ...QUERY_PARAMS_CALLIN,
      ...(queue && queue.length > 0 && { queue: queue.join(',') }),
      dateBegin: `${toISOFormat(dateBegin)} ${QUERY_PARAMS_CARDS.hourBegin}`,
      dateEnd: `${toISOFormat(dateEnd)} ${QUERY_PARAMS_CARDS.hourEnd}`,
      timeStart: timeStart,
      timeEnd: timeEnd,
      teamId: ``,
      ...(agent &&
        agent.length > 0 && { agent: agent.join(','), agentName: agentNames })
    };
    OutgoingCallReportingService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      queryParams
    )
      .then((response) => {
        const { listCallDetailedSyntheticCallCenterDTO } = response.data.data;
        if (
          validateGraphData(
            listCallDetailedSyntheticCallCenterDTO,
            'Gráfico de Chamadas Realizadas'
          )
        ) {
          setDataOutCallGraph(listCallDetailedSyntheticCallCenterDTO);
        }
      })
      .catch((error) => {
        console.log('error na request chamadas realizadas ', error);
      });
  };
  /**
   * @description: Fetches combined call data for both incoming and outgoing calls with pagination
   * @returns {Promise} - A promise that resolves to the combined call data
   * @param {Array} queue - The queue(s) to filter the data
   * @param {string} dateBegin - The start date for the data
   * @param {string} dateEnd - The end date for the data
   * @param {Array} agent - The agent(s) to filter the data
   * @param {number} pageSize - Number of items per page (default: 1000)
   */
  const fetchCombinedCallData = async (
    queue,
    dateBegin,
    dateEnd,
    agent,
    pageSize = 1000
  ) => {
    try {
      const agentNames = getAgentNames(agent);

      const baseParams = {
        ...QUERY_PARAMS_COMBINED_CALL,
        ...(queue && queue.length > 0 && { queue: queue.join(',') }),
        dateBegin: `${toISOFormat(dateBegin)} ${QUERY_PARAMS_CARDS.hourBegin}`,
        dateEnd: `${toISOFormat(dateEnd)} ${QUERY_PARAMS_CARDS.hourEnd}`,
        timeStart: timeStart,
        timeEnd: timeEnd,
        ...(agent &&
          agent.length > 0 && {
            agent: agent.join(','),
            agentName: agentNames
          })
      };

      const fetchPaginatedData = async (service, dataType) => {
        let allData = [];
        let currentPage = 1;
        let hasMoreData = true;

        while (hasMoreData) {
          const response = await service.getAllReportsType(
            REPORT_TYPE_DETAILEDSYNTHETIC,
            currentPage,
            {
              ...baseParams,
              dataType: dataType,
              quantity: pageSize,
              page: currentPage
            }
          );

          if (
            response.data.data &&
            response.data.data.listCallDetailedSyntheticCallCenterDTO
          ) {
            const pageData =
              response.data.data.listCallDetailedSyntheticCallCenterDTO;
            allData = [...allData, ...pageData];

            const totalItems = response.data.data.quantity || 0;
            const retrievedItems = allData.length;

            hasMoreData =
              pageData.length === pageSize && retrievedItems < totalItems;
            currentPage++;
          } else {
            hasMoreData = false;
          }
        }

        return allData;
      };

      const [incomingData, outgoingData] = await Promise.all([
        fetchPaginatedData(RecievedCallReportingService, 'incoming'),
        fetchPaginatedData(OutgoingCallReportingService, 'outgoing')
      ]);

      setCombinedCallData({
        incoming: incomingData,
        outgoing: outgoingData
      });

      return {
        incoming: { listCallDetailedSyntheticCallCenterDTO: incomingData },
        outgoing: { listCallDetailedSyntheticCallCenterDTO: outgoingData }
      };
    } catch (error) {
      console.error('Erro ao buscar dados: ', error);
      throw error;
    }
  };

  /**
   * @description: Aggregates data for the bar chart
   * @returns {Object} - Contains labels, answered, and abandoned calls
   * @param {Array} dataArray - Input data array
   * @type {Object}
   * @property {string[]} labels - Agent names
   * @property {number[]} answered - Handled calls
   * @property {number[]} abandoned - Abandoned calls
   * @description: (aggregation) Iterates through the data array, grouping handled and abandoned calls by agent
   */
  function aggregateBarChartData(dataArray) {
    if (!dataArray || dataArray.length === 0)
      return { labels: [], answered: [], abandoned: [] };

    const aggregation = dataArray.reduce((acc, item) => {
      const name = item.nameAgent?.trim() || 'Agente Desconhecido';
      if (!acc[name]) {
        acc[name] = { answered: 0, abandoned: 0 };
      }
      acc[name].answered += item.answered ?? 0;
      acc[name].abandoned += item.abandoned ?? 0;
      return acc;
    }, {});

    const sortedEntries = Object.entries(aggregation).sort((a, b) => {
      const totalA = a[1].answered + a[1].abandoned;
      const totalB = b[1].answered + b[1].abandoned;
      return totalB - totalA;
    });

    const labels = sortedEntries.map(([name]) => name);
    const answered = sortedEntries.map(([, data]) => data.answered);
    const abandoned = sortedEntries.map(([, data]) => data.abandoned);

    return { labels, answered, abandoned };
  }

  /**
   * @description: Aggregates data for the pie chart
   * @returns {Object} - Contains labels and values
   * @param {Array} dataArray - Input data array
   * @type {Object}
   * @property {string[]} labels - Agent names
   * @property {number[]} values - Total calls (answered + abandoned)
   * @description: (aggregation) Iterates through the data array, grouping answered and abandoned calls by agent
   */
  function aggregatePieData(dataArray) {
    if (!dataArray || dataArray.length === 0) {
      return { labels: [], values: [] };
    }

    const aggregation = dataArray.reduce((result, item) => {
      const name = item.nameAgent?.trim() || 'Agente Desconhecido';
      if (!result[name]) result[name] = { answered: 0, abandoned: 0 };
      result[name].answered += item.answered ?? 0;
      result[name].abandoned += item.abandoned ?? 0;
      return result;
    }, {});

    const sorted = Object.entries(aggregation).sort(
      ([, a], [, b]) => b.answered + b.abandoned - (a.answered + a.abandoned)
    );

    const labels = sorted.map(([name]) => name);
    const values = sorted.map(([, data]) => data.answered + data.abandoned);

    return { labels, values };
  }

  function convertTimeToSeconds(timeString) {
    if (!timeString) return 0;
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  function formatSecondsToTime(seconds) {
    const secs = Math.floor(seconds);
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor((secs % 3600) / 60);
    const secsRemainder = Math.floor(secs % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${secsRemainder.toString().padStart(2, '0')}`;
  }

  /**
   * @description: (formatInterval) formats the interval string to only show the start time
   * backend sends the time range as "12:00 as 13:00", but is necessary "12:00"
   * @returns {string} - The formatted interval
   */
  const formatInterval = (interval) => {
    return interval.split('as')[0].trim();
  };

  /**
   * @description: (aggregateLineChartData) processes the data for the line chart
   * @returns {Object} - Contains the labels and datasets for the chart
   * @param {Array} data - Input data array
   * @param {string} type - Type of data (incoming or outgoing)
   * @type {Object}
   */
  const aggregateLineChartData = (data) => {
    const groupedData = data.reduce((acc, item) => {
      const interval = item.interval;
      if (!acc[interval]) {
        acc[interval] = {
          answered: 0,
          abandoned: 0,
          total: 0,
          tmeSeconds: 0,
          tmeCount: 0,
          serviceLevelValues: []
        };
      }
      acc[interval].answered += item.answered || 0;
      acc[interval].abandoned += item.abandoned || 0;
      acc[interval].total += (item.answered || 0) + (item.abandoned || 0);

      if (item.tme) {
        const seconds = convertTimeToSeconds(item.tme);
        acc[interval].tmeSeconds += seconds;
        acc[interval].tmeCount += 1;
      }

      if (item.serviceLevel) {
        const numericValue = parseFloat(item.serviceLevel.replace('%', ''));
        if (!isNaN(numericValue)) {
          acc[interval].serviceLevelValues.push(numericValue);
        }
      }
      return acc;
    }, {});

    const allIntervals = [
      ...incoming.map((item) => item.interval),
      ...outgoing.map((item) => item.interval)
    ];

    const uniqueIntervals = [...new Set(allIntervals)].sort();

    const formattedIntervals = uniqueIntervals
      .map(formatInterval)
      .sort((a, b) => {
        const timeA = new Date(`2000-01-01T${a}:00`);
        const timeB = new Date(`2000-01-01T${b}:00`);
        return timeA - timeB;
      });

    const tooltipData = formattedIntervals.map((time) => {
      const originalInterval = uniqueIntervals.find((int) =>
        int.startsWith(time)
      );
      const group = groupedData[originalInterval] || {
        answered: 0,
        abandoned: 0,
        total: 0,
        tmeSeconds: 0,
        tmeCount: 0,
        serviceLevelValues: []
      };

      const avgTme =
        group.tmeCount > 0
          ? formatSecondsToTime(group.tmeSeconds / group.tmeCount)
          : '00:00:00';

      const avgServiceLevel =
        group.serviceLevelValues.length > 0
          ? `${Math.round(
              group.serviceLevelValues.reduce((sum, val) => sum + val, 0) /
                group.serviceLevelValues.length
            )}%`
          : '0%';

      return {
        total: group.total,
        tme: avgTme,
        serviceLevel: avgServiceLevel
      };
    });

    return {
      chartData: {
        // Agrupa os dados do gráfico aqui
        labels: formattedIntervals,
        datasets: [
          {
            label: 'Atendidas',
            data: formattedIntervals.map((time) => {
              const originalInterval = uniqueIntervals.find((int) =>
                int.startsWith(time)
              );
              return groupedData[originalInterval]?.answered || 0;
            }),
            borderColor: '#00A07C',
            pointBackgroundColor: '#00A07C',
            tension: 0.2
          },
          {
            label: 'Abandonadas',
            data: formattedIntervals.map((time) => {
              const originalInterval = uniqueIntervals.find((int) =>
                int.startsWith(time)
              );
              return groupedData[originalInterval]?.abandoned || 0;
            }),
            borderColor: '#d9534f',
            pointBackgroundColor: '#d9534f',
            tension: 0.2
          }
        ]
      },
      tooltipData: tooltipData
    };
  };

  /**
   * @description: (pieDataIncoming, pieDataOutgoing) implements the aggregatePieData
   * (incomingBarChartData and outgoingBarChartData) implements the aggregateBarChartData
   * (incomingLineChartData and outgoingLineChartData) implements the aggregateLineChartData
   * function with the data that has been separated.
   * The results will be passed to the charts components.
   */
  const incomingBarChartData = aggregateBarChartData(incoming);
  const outgoingBarChartData = aggregateBarChartData(outgoing);
  const pieDataIncoming = aggregatePieData(incoming);
  const pieDataOutgoing = aggregatePieData(outgoing);
  const incomingLineChartData = aggregateLineChartData(incoming);
  const outgoingLineChartData = aggregateLineChartData(outgoing);

  const aggregateCallsPerHour = (dataArray, tooltipData) => {
    if (!dataArray || dataArray.length === 0) {
      return {
        chartData: {
          labels: [],
          datasets: [
            {
              label: 'Chamadas Atendidas',
              data: [],
              backgroundColor: '#00A07C'
            },
            {
              label: 'Chamadas Abandonadas',
              data: [],
              backgroundColor: '#d9534f'
            }
          ]
        },
        additionalData: []
      };
    }

    const tooltipDataMap = {};
    if (tooltipData && tooltipData.length > 0) {
      tooltipData.forEach((item) => {
        const intervalParts = item.interval?.split(' as ') || [];
        if (intervalParts.length > 0) {
          const hour = intervalParts[0].trim();
          tooltipDataMap[hour] = item;
        }
      });
    }

    const groupedData = dataArray.reduce((acc, item) => {
      const intervalParts = item.interval.split(' as ');
      const hour = intervalParts[0].trim();

      if (!acc[hour]) {
        acc[hour] = {
          answered: 0,
          abandoned: 0,
          rawItems: []
        };
      }

      acc[hour].answered += item.answered || 0;
      acc[hour].abandoned += item.abandoned || 0;
      acc[hour].rawItems.push(item);

      return acc;
    }, {});

    const sortedHours = Object.keys(groupedData).sort((a, b) => {
      const timeA = new Date(`2000-01-01T${a}:00`);
      const timeB = new Date(`2000-01-01T${b}:00`);
      return timeA - timeB;
    });

    const additionalData = sortedHours.map((hour) => {
      if (tooltipDataMap[hour]) {
        return tooltipDataMap[hour];
      }

      const hourData = groupedData[hour];
      const total = hourData.answered + hourData.abandoned;

      let tmeTotalSeconds = 0;
      let tmeCount = 0;

      hourData.rawItems.forEach((item) => {
        if (item.tme) {
          const [hours, minutes, seconds] = item.tme.split(':').map(Number);
          tmeTotalSeconds += hours * 3600 + minutes * 60 + seconds;
          tmeCount++;
        }
      });

      const tme =
        tmeCount > 0
          ? new Date((tmeTotalSeconds / tmeCount) * 1000)
              .toISOString()
              .substr(11, 8)
          : '00:00:00';

      let serviceLevelTotal = 0;
      let serviceLevelCount = 0;

      hourData.rawItems.forEach((item) => {
        if (item.serviceLevel) {
          const numericValue = parseFloat(item.serviceLevel.replace('%', ''));
          if (!isNaN(numericValue)) {
            serviceLevelTotal += numericValue;
            serviceLevelCount++;
          }
        }
      });

      const serviceLevel =
        serviceLevelCount > 0
          ? `${Math.round(serviceLevelTotal / serviceLevelCount)}%`
          : '0%';

      return {
        total,
        tme,
        serviceLevel
      };
    });

    return {
      chartData: {
        labels: sortedHours,
        datasets: [
          {
            label: 'Chamadas Atendidas',
            data: sortedHours.map((hour) => groupedData[hour].answered),
            backgroundColor: '#00A07C'
          },
          {
            label: 'Chamadas Abandonadas',
            data: sortedHours.map((hour) => groupedData[hour].abandoned),
            backgroundColor: '#d9534f'
          }
        ]
      },
      additionalData
    };
  };

  const incomingChartData = aggregateCallsPerHour(
    incoming,
    incomingLineChartData.tooltipData
  );
  const outgoingChartData = aggregateCallsPerHour(
    outgoing,
    outgoingLineChartData.tooltipData
  );
  /**
   * @description: (calculateAbandonmentRate) calculates the abandonment rate for the (Taxa de Abandono) Card/KPI
   * @returns {number} - The abandonment rate in percentage
   */
  const calculateAbandonmentRate = (data) => {
    if (!data || data.length === 0) return 0;

    const total = data.reduce(
      (sum, call) => sum + (call.answered || 0) + (call.abandoned || 0),
      0
    );

    const abandoned = data.reduce(
      (sum, call) => sum + (call.abandoned || 0),
      0
    );

    return total > 0 ? ((abandoned / total) * 100).toFixed(1) : 0;
  };

  /**
   * @description: (calculateAveragePerAgent) calculates the average number of calls per agent,
   * for the (Média por Operador) Card/KPI
   * @returns {number} - The average number of calls per agent
   */
  const calculateAveragePerAgent = (incomingData, outgoingData) => {
    const allAgents = [
      ...new Set([
        ...incomingData.map((item) => item.nameAgent),
        ...outgoingData.map((item) => item.nameAgent)
      ])
    ];

    if (allAgents.length === 0) return 0;

    const totalCalls =
      incomingData.reduce(
        (sum, call) => sum + (call.answered || 0) + (call.abandoned || 0),
        0
      ) +
      outgoingData.reduce(
        (sum, call) => sum + (call.answered || 0) + (call.abandoned || 0),
        0
      );

    return (totalCalls / allAgents.length).toFixed(1);
  };

  const getDataForPbxipIncomingCallGraph = () => {
    PbxipCallReceivedService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      QUERY_PARAMS_PBXIP
    )
      .then((response) => {
        const { listCallDetailedSyntheticCallCenterDTO } = response.data.data;
        if (
          validateGraphData(
            listCallDetailedSyntheticCallCenterDTO,
            'Gráfico PBXIP de Chamadas Recebidas'
          )
        ) {
          setDataForIncomingPbxipGraph(listCallDetailedSyntheticCallCenterDTO);
        }
      })
      .catch((error) => {
        console.log('error na request PBXIP chamadas recebidas ', error);
      });
  };

  const getDataForPbxipOutgoingCallGraph = () => {
    PbxipCallOutgoingService.getAllReportsType(
      REPORT_TYPE_DETAILEDSYNTHETIC,
      PAGE,
      QUERY_PARAMS_PBXIP
    )
      .then((response) => {
        const { listCallDetailedSyntheticCallCenterDTO } = response.data.data;
        if (
          validateGraphData(
            listCallDetailedSyntheticCallCenterDTO,
            'Gráfico PBXIP de Chamadas Realizadas'
          )
        ) {
          setDataForOutPbxipGraph(listCallDetailedSyntheticCallCenterDTO);
        }
      })
      .catch((error) => {
        console.log('error na request PBXIP chamadas realizadas ', error);
      });
  };

  /**
   * @description: (getDateBegin) returns the first day of the current month,
   * used to set the date filter's default value to the current month's first day
   * @returns {string} - The first day of the current month in dd/LL/yyyy format
   * @type {string}
   * @property {string} dateBegin - The first day of the current month
   */
  const getDateBegin = () => {
    const date = new Date();
    const firstDayMonth = new Date(
      date.getFullYear('pt-br'),
      date.getMonth('pt-br'),
      1
    );
    const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
    return dateBegin;
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const toISOFormat = (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');

    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${MM}-${DD}-${YYYY}`;
  };

  useEffect(() => {
    getUser(true);
  }, []);

  useEffect(() => {
    let checkIsFromPBXIP = window.location.href.split('/');
    checkIsFromPBXIP.filter(async (item) => {
      if (item === 'PBXIP') {
        setIsFromPBXIP(true);
        getDataForPbxipIncomingCallGraph();
        getDataForPbxipOutgoingCallGraph();
      } else if (item === 'callcenter') {
        await fetchQueues();
        setIsFromPBXIP(false);
      }
    });
  }, []);
  return (
    <>
      <AlternativeHeader />

      <Container className="mt--6">
        <Row
          style={{
            paddingBottom: '1.5rem',
            display: `${isFromPBXIP ? 'none' : 'flex'}`
          }}
        >
          <Col md="12">
            <label className="form-control-label">Fila</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  closeMenuOnSelect={false}
                  isClearable={true}
                  dataOptions={queues}
                  placeholder="Selecione a fila para buscar dados"
                  isMulti={true}
                  value={props.value}
                  valueController={setValue}
                  fieldName="queuesid"
                  labelName="name"
                  valueName="id"
                />
              )}
              control={control}
              name="queuesid"
              defaultValue={''}
            />
          </Col>
        </Row>
        <Row
          className="mb-3"
          style={{ display: `${isFromPBXIP ? 'none' : 'flex'}` }}
        >
          <Col md="4">
            {/* Filtro Data inicial*/}
            <label className="form-control-label">Data inicial*</label>
            <Controller
              render={(props) => (
                <Datepicker
                  fieldName="dateBegin"
                  valueController={setValue}
                  defaultValue={props.value}
                />
              )}
              control={control}
              name="dateBegin"
              rules={dateRules}
              defaultValue={getMemorizedFilters()?.dateBegin ?? getDateBegin()}
            />
            <ErrorMessage
              errors={errors}
              name="dateBegin"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>

          <Col md="4">
            {/* Filtro Data final*/}
            <label className="form-control-label">Data final*</label>
            <Controller
              render={(props) => (
                <Datepicker
                  fieldName="dateEnd"
                  valueController={setValue}
                  defaultValue={props.value}
                />
              )}
              control={control}
              name="dateEnd"
              defaultValue={
                getMemorizedFilters()?.dateEnd ??
                new Date().toLocaleDateString('pt-br')
              }
              rules={{
                ...dateRules,
                validate: (value) => {
                  if (
                    new Date(toISOFormat(value, true)) <
                    new Date(toISOFormat(getValues()['dateBegin'], true))
                  ) {
                    return 'A data final não pode ser anterior à inicial!';
                  }
                  return true;
                }
              }}
            />
            <ErrorMessage
              errors={errors}
              name="dateEnd"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>

          <Col md="4">
            {/* Filtro de Agentes*/}
            <label className="form-control-label">Agente</label>
            <Controller
              render={(props) => (
                <FlexSelect
                  dataOptions={users}
                  isMulti={true}
                  isClearable={true}
                  value={props.value}
                  valueController={setValue}
                  closeMenuOnSelect={false}
                  fieldName="agent"
                  labelName="name"
                  valueName="agent_code"
                />
              )}
              control={control}
              name="agent"
              defaultValue={getMemorizedFilters()?.agent ?? ''}
            />
          </Col>
        </Row>
        {/* Botão Buscar*/}
        <Button
          style={{
            ...buttonStyle(systemConfiguration.primary_color),
            display: isFromPBXIP ? 'none' : 'flex',
            marginBottom: '1rem'
          }}
          type="button"
          onClick={onSubmit}
        >
          Buscar
        </Button>
        {!isFromPBXIP && (
          <TopCardsContainer>
            {/* Taxa de Abandono: ocupa 2 linhas */}
            <div id="big-card">
              <TopCards title="Taxa de Abandono">
                <div>
                  <span style={styleTime}>
                    {calculateAbandonmentRate(incoming)}%
                  </span>
                  <div style={{ fontSize: '0.8rem' }}>(Recebidas)</div>
                  <span style={styleTime}>
                    {calculateAbandonmentRate(outgoing)}%
                  </span>
                  <div style={{ fontSize: '0.8rem' }}>(Realizadas)</div>
                </div>
              </TopCards>
            </div>

            {/* Restante dos Cards */}
            {/** T.M.A **/}
            <TopCards title="T.M.A">
              <span style={styleTime}>{getTMA(dataCarts)}</span>
            </TopCards>

            {/** T.M.E **/}
            <TopCards title="T.M.E">
              <span style={styleTime}>{getTME(dataCarts)}</span>
            </TopCards>

            {/** Nível de Serviço **/}
            <TopCards
              title={
                <div className="d-flex w-100 justify-content-center align-items-center">
                  <span className="mr-2">Nível de Serviço</span>
                  <FormTooltip
                    text="O cálculo do nível de serviço considera as chamadas recebidas e realizadas que foram atendidas dentro do tempo limite pré-determinado para atendimento"
                    color="##f1e7f1"
                  />
                </div>
              }
            >
              <div className="d-flex flex-row justify-content-center align-items-start">
                <div className="d-flex flex-column text-center mr-4">
                  <span
                    className="my-0 font-weight-normal"
                    style={{ fontSize: '2.0rem' }}
                  >
                    {(calculeConform &&
                      calculeConform([
                        ...(Array.isArray(dataServiceLevel)
                          ? dataServiceLevel
                          : []),
                        ...(Array.isArray(dataForOutCallGraph)
                          ? dataForOutCallGraph
                          : [])
                      ])) ||
                      '0'}
                  </span>
                  <span
                    className="my-0 font-weight-normal"
                    style={{ fontSize: '0.8rem' }}
                  >
                    Conforme
                  </span>
                </div>
                <div className="d-flex flex-column text-center">
                  <span
                    className="font-weight-normal"
                    style={{ fontSize: '2.0rem' }}
                  >
                    {(calculeNotConfor &&
                      calculeNotConfor([
                        ...(Array.isArray(dataServiceLevel)
                          ? dataServiceLevel
                          : []),
                        ...(Array.isArray(dataForOutCallGraph)
                          ? dataForOutCallGraph
                          : [])
                      ])) ||
                      '0'}
                  </span>
                  <span
                    className="font-weight-normal"
                    style={{ fontSize: '0.8rem' }}
                  >
                    Não Conforme
                  </span>
                </div>
              </div>
            </TopCards>

            {/** Média por Operador **/}
            <TopCards title="Média por Operador">
              <div className="text-center">
                <span style={styleTime}>
                  {calculateAveragePerAgent(incoming, outgoing)}
                </span>
                <div style={{ fontSize: '0.8rem' }}>
                  Total de ligações/agente
                </div>
              </div>
            </TopCards>

            {/** Chamadas Recebidas **/}
            <TopCards title="Chamadas Recebidas">
              <div className="d-flex flex-row justify-content-center">
                <div className="d-flex flex-column text-center mr-4">
                  <span
                    className="my-0 font-weight-normal"
                    style={{ fontSize: '2.0rem' }}
                  >
                    {getAnsweredCalls(dataCarts)}
                  </span>
                  <span className="my-0" style={{ fontSize: '0.8rem' }}>
                    Atendidas
                  </span>
                </div>
                <div className="d-flex flex-column text-center">
                  <span className="my-0" style={{ fontSize: '2.0rem' }}>
                    {getAbandonedCalls(dataCarts)}
                  </span>
                  <span className="my-0" style={{ fontSize: '0.8rem' }}>
                    Abandonadas
                  </span>
                </div>
              </div>
            </TopCards>

            {/** Chamadas Realizadas **/}
            <TopCards title="Chamadas Realizadas">
              <div className="d-flex flex-row justify-content-center">
                <div className="d-flex flex-column text-center mr-4">
                  <span
                    className="my-0 font-weight-normal"
                    style={{ fontSize: '2.0rem' }}
                  >
                    {getOutgoingAnsweredCalls(dataForOutCallGraph)}
                  </span>
                  <span className="my-0" style={{ fontSize: '0.8rem' }}>
                    Atendidas
                  </span>
                </div>
                <div className="d-flex flex-column text-center">
                  <span className="my-0" style={{ fontSize: '2.0rem' }}>
                    {getOutgoingAbandonedCalls(dataForOutCallGraph)}
                  </span>
                  <span className="my-0" style={{ fontSize: '0.8rem' }}>
                    Abandonadas
                  </span>
                </div>
              </div>
            </TopCards>
          </TopCardsContainer>
        )}
        <Row>
          {/* Gráfico de Barras Chamadas Recebidas por intervalo de tempo*/}
          <Col
            md={
              dataForIncomingCallGraph.length > 15 ? { size: 12 } : { size: 6 }
            }
          >
            {dataForIncomingCallGraph.length > 0 && isFromPBXIP === false ? (
              <CallCenterCallGraphicsIncomingCalls
                dateBegin={dateBeginValue}
                dateEnd={dateEndValue}
                dataGraphics={dataForIncomingCallGraph}
              />
            ) : null}
          </Col>
          {/* Gráfico de Barras Chamadas Realizadas por intervalo de tempo*/}
          <Col
            md={dataForOutCallGraph.length > 15 ? { size: 12 } : { size: 6 }}
          >
            {dataForOutCallGraph.length > 0 && isFromPBXIP === false ? (
              <CallCenterCallGraphicsOutgoingCalls
                dateBegin={dateBeginValue}
                dateEnd={dateEndValue}
                dataGraphics={dataForOutCallGraph}
              />
            ) : null}
          </Col>
        </Row>
        <Row className="mb-3">
          {loading ? (
            <Col md="12">
              <p>Carregando...</p>
            </Col>
          ) : (
            <>
              {/* Gráfico de Barras Chamadas Recebidas por Agente*/}
              <Col md="6">
                {incoming.length > 0 && isFromPBXIP === false ? (
                  <AgentHorizontalBarChart
                    title="Chamadas Recebidas por Agente"
                    data={incomingBarChartData}
                  />
                ) : null}
              </Col>
              {/* Gráfico de Barras Chamadas Realizadas por Agente*/}
              <Col md="6">
                {outgoing.length > 0 ? (
                  <AgentHorizontalBarChart
                    title="Chamadas Realizadas por Agente"
                    data={outgoingBarChartData}
                  />
                ) : null}
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* Gráfico de Pizza Distribuição de Chamadas Recebidas por Agente*/}
          <Col md="6">
            {dataForIncomingCallGraph.length > 0 && isFromPBXIP === false ? (
              <AgentPieChart
                title="Distribuição de Chamadas Recebidas"
                data={pieDataIncoming}
              />
            ) : null}
          </Col>
          {/* Gráfico de Pizza Distribuição de Chamadas Realizadas por Agente*/}
          <Col md="6">
            {dataForOutCallGraph.length > 0 && isFromPBXIP === false ? (
              <AgentPieChart
                title="Distribuição de Chamadas Realizadas"
                data={pieDataOutgoing}
              />
            ) : null}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xl="12">
            {incoming.length > 0 && isFromPBXIP === false ? (
              <CallsPerHourBarChart
                data={incomingChartData.chartData}
                title="Chamadas Recebidas por Hora"
                additionalData={incomingChartData.additionalData}
              />
            ) : null}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xl="12">
            {outgoing.length > 0 && isFromPBXIP === false ? (
              <CallsPerHourBarChart
                data={outgoingChartData.chartData}
                title="Chamadas Realizadas por Hora"
                additionalData={outgoingChartData.additionalData}
              />
            ) : null}
          </Col>
        </Row>

        <Row>
          <Col md={{ size: 12 }}>
            {dataForIncomingPbxipGraph.length > 0 && isFromPBXIP === true ? (
              <PbxipCallGraphicsIncomingCalls
                month={currentMont()}
                dataGraphics={dataForIncomingPbxipGraph}
              />
            ) : null}
          </Col>
          <Col md={{ size: 12 }}>
            {dataForOutPbxipGraph.length > 0 && isFromPBXIP === true ? (
              <PbxipCallGraphicsOutgoingCalls
                month={currentMont()}
                dataGraphics={dataForOutPbxipGraph}
              />
            ) : null}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
